import axios from "axios";
import { useRef, useState, useEffect } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { toast } from "sonner";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { parsePhoneNumberFromString } from "libphonenumber-js";

const ContactForm = ({ noBg = false }) => {
  const recaptchaRef = useRef(null);
  const formRef = useRef(null);
  const containerRef = useRef(null);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone_no, setPhoneNo] = useState("");
  const [message, setMessage] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [countryCode, setCountryCode] = useState("91");

 const isValidPhone = () => {
  const phone = parsePhoneNumberFromString(`+${phone_no}`);
  return phone ? phone.isValid() : false;
};



  
  // const Site_Key = "6Ldi7EAsAAAAAD0hvK3eJirqbAxL0U4s_Zl8i266"; //Local
  const Site_Key = "6LcN8kcsAAAAAPdpBPmv9yNBKdCuo-MhCFoZoflQ";  //Live
  
  // const Api_Url = "http://192.168.1.230:8085/main/webreact/";  //local
  const Api_Url = "https://app.cheransoftwares.com/webreact/"; //live

  // useEffect(() => {
  //   // Get the form container position
  //   const updateFormPosition = () => {
  //     if (formRef.current && containerRef.current) {
  //       const container = containerRef.current;
  //       const form = formRef.current;
  //       const containerRect = container.getBoundingClientRect();
  //       const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        
  //       // Calculate the original position
  //       const containerTop = containerRect.top + scrollTop;
  //       const containerLeft = containerRect.left;
  //       const containerWidth = container.offsetWidth;
        
  //       // Store in data attributes
  //       form.dataset.originalTop = containerTop;
  //       form.dataset.originalLeft = containerLeft;
  //       form.dataset.originalWidth = containerWidth;
        
  //       // Set container position relative to maintain flow
  //       container.style.position = 'relative';
  //     }
  //   };

  //   const handleScroll = () => {
  //     if (formRef.current && containerRef.current) {
  //       const form = formRef.current;
  //       const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  //       const originalTop = parseInt(form.dataset.originalTop) || 0;
  //       const originalLeft = parseInt(form.dataset.originalLeft) || 0;
  //       const originalWidth = parseInt(form.dataset.originalWidth) || 0;
        
  //       // When scrolled past the form's original position
  //       if (scrollTop > originalTop - 100) { // 100px before reaching
  //         form.classList.add('contact-form-sticky-active');
  //         form.style.position = 'fixed';
  //         form.style.top = '100px';
  //         form.style.left = `${originalLeft}px`;
  //         form.style.width = `${originalWidth}px`;
  //         form.style.zIndex = '1000';
  //       } else {
  //         form.classList.remove('contact-form-sticky-active');
  //         form.style.position = 'static';
  //         form.style.top = 'auto';
  //         form.style.left = 'auto';
  //         form.style.width = '100%';
  //         form.style.zIndex = 'auto';
  //       }
  //     }
  //   };

  //   // Initial setup
  //   setTimeout(() => {
  //     updateFormPosition();
  //     handleScroll();
  //   }, 100);

  //   window.addEventListener('resize', updateFormPosition);
  //   window.addEventListener('scroll', handleScroll);
    
  //   // Re-check after images load
  //   window.addEventListener('load', updateFormPosition);

  //   return () => {
  //     window.removeEventListener('resize', updateFormPosition);
  //     window.removeEventListener('scroll', handleScroll);
  //     window.removeEventListener('load', updateFormPosition);
  //   };
  // }, []);

  const handleChange = (e) => {
    const digitsOnly = e.target.value.replace(/\D/g, "");
    setPhoneNo(digitsOnly.slice(0, 10));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  const captcha_token = recaptchaRef.current.getValue();

  if (!captcha_token) {
    toast.error("Please verify you are not a robot");
    return;
  }

  const phoneNumber = parsePhoneNumberFromString(`+${phone_no}`);

  if (!phoneNumber || !phoneNumber.isValid()) {
    setPhoneError("Please enter a valid mobile number");
    return;
  }

  const payload = {
    name,
    lead_email: email,
    quick_country_code: phoneNumber.countryCallingCode, 
    phonenumber1: phoneNumber.nationalNumber,         
    note_name: message,
    captcha_token,
  };

  try {
    await axios.post(
      `${Api_Url}webapp_leads/website_form_store`,
      payload,
      { headers: { "Content-Type": "application/json" } }
    );

    toast.success("Form submitted successfully");
    recaptchaRef.current.reset();
    setName("");
    setEmail("");
    setPhoneNo("");
    setMessage("");
  } catch (error) {
    toast.error(error.response?.data?.message || "Something went wrong");
  }
};


  return (
    <div ref={containerRef} className="contact-form-container">
      <form
        ref={formRef}
        onSubmit={handleSubmit}
        className={`contact-form-original ${noBg ? 'form-dark' : 'form-light'}`}
        style={{
          backgroundColor: noBg ? "transparent" : "#fff",
          padding: "20px",
          borderRadius: "8px",
          boxShadow: "0 2px 10px rgba(0,0,0,0.1)"
        }}
      >
        <div className="text-center text-dark fw-bold fs-4">For Enquiry</div>
        <p className="text-dark mb-0">Name</p>
        <input
          type="text"
          placeholder="Your Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
          className="mb-1"
        />
        
        
        <p className="text-dark mb-0">Phone No</p>

            <PhoneInput
  country={'in'}
  value={phone_no}
  onChange={(value, country) => {
    setPhoneNo(value);
    setPhoneError("");
  }}
  enableSearch={true}           // user can search country
  disableDropdown={false}       // user CAN select country
  countryCodeEditable={false}   // ❌ user cannot edit +XX
  inputStyle={{
    width: "100%",
    height: "40px"
  }}
  containerStyle={{ marginBottom: "5px" }}
  inputProps={{ required: true }}
/>



              {phoneError && (
                <small className="text-danger">{phoneError}</small>
              )}





        <p className="text-dark mb-0">Message</p>
        <textarea
          placeholder="Message"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          required
          className="mb-3 form-control "
          rows={2}
        />
        
        <ReCAPTCHA
          sitekey={Site_Key}
          ref={recaptchaRef}
          className="mb-3"
        />

        <button 
          type="submit" 
          className="btn py-2 px-2 text-white" 
          style={{ backgroundColor: "#2DBB62", fontSize: "13px" }}
        >
          Send Message
        </button>
      </form>
    </div>
  );
};

export default ContactForm;